@if ((asset() | canDisplayAsset) && asset().type !== 'audio') {
  @let imgSrc =
    asset().version_data
      | assetVersionUrl
        : asset()
        : asset().version_data.status
        : width()
        : height()
        : asset().watermark_enabled && !!gallery().watermark;

  @if (asset().type === 'image' || asset().type === 'document') {
    <!-- primary image -->
    @if (imgSrc) {
      <img
        [attr.data-picflow-hide]="true"
        [class.hovering]="hovering()"
        [class.rounded]="roundedCorners()"
        [src]="preview() || imgSrc"
        alt=""
      />
    }

    <!-- watermark loading icon-->
    @if (
      (asset() | canWatermarkAsset) &&
      gallery()?.watermark &&
      asset().watermark_enabled &&
      !asset().version_data.watermark_uuid
    ) {
      <div class="asset-spinner">
        <app-loading-indicator [color]="'white'" [size]="'small'"></app-loading-indicator>
      </div>
    }
  } @else if (asset().type === 'video') {
    <!-- Video -->
    @if (isDesktop() || asset().autoplay) {
      <!-- Primary video -->
      <app-video-viewer
        [class.hovering]="hovering()"
        [class.rounded]="roundedCorners()"
        [videoData]="$any(asset().version_data.data)"
        [assetVersion]="asset().version_data"
        [asset]="asset()"
        [uuid]="asset().version_data.uuid"
        [poster]="imgSrc"
        [active]="(hovering() || asset().autoplay) && !asset()['tempUploadingPoster']"
        [showUi]="false"
        [handleUi]="false"
        [autoplay]="(hovering() || asset().autoplay) && !asset()['tempUploadingPoster']"
        [muted]="true"
        [allowUnmute]="isDesktop()"
        [loop]="true"
        [targetWidth]="width()"
        [reportTimeChange]="true"
        #video
        (onTimeChange)="onTimeChange()"
      >
      </app-video-viewer>
    } @else {
      <img
        [attr.data-picflow-hide]="true"
        [class.hovering]="hovering()"
        [class.rounded]="roundedCorners()"
        [src]="imgSrc"
        alt=""
      />
    }

    <!-- Video play/loading indicator -->
    @if (!video() || (video().status !== 'playing' && !asset()['tempUploadingPoster'])) {
      <div class="video-indicator" [class.loading]="video()?.status === 'loading'">
        <app-svg src="/assets/icons/play.svg"></app-svg>
      </div>
    }

    <!-- Video poster replacement loading indicator -->
    @if (asset()['tempUploadingPoster']) {
      <div class="asset-spinner">
        <app-loading-indicator [color]="'white'" [size]="'small'"></app-loading-indicator>
      </div>
    }
  }
} @else if (asset().version_data.status === 'pending' || asset().version_data.status === 'in_progress' || preview()) {
  <div class="asset-spinner">
    <app-loading-indicator [color]="'white'" [size]="'small'"></app-loading-indicator>
  </div>
  @if (preview()) {
    <img [attr.data-picflow-hide]="true" [src]="preview()" alt="" />
  } @else if (asset().type === 'audio' || asset().type === 'non_preview') {
    <div class="asset-placeholder" [class.dark]="darkBackground()"></div>
  }
} @else {
  <app-non-preview-file
    [asset]="asset()"
    [gallery]="gallery()"
    [showFilename]="showFilename()"
    [darkBackground]="darkBackground()"
    [class.hovering]="hovering()"
    [class.rounded]="roundedCorners()"
    [showBorder]="true"
  ></app-non-preview-file>
}

<!-- Feedback -->
@if (
  isDesktop() &&
  galleryPermissions()?.can_review_if_authenticated &&
  allowedAndEnabledFeedbackOptions() &&
  (allowedAndEnabledFeedbackOptions()?.includes('favourite') ||
    allowedAndEnabledFeedbackOptions()?.includes('status')) &&
  ['completed', 'failed'].includes(asset().version_data.status)
) {
  @if (hovering()) {
    <app-asset-feedback
      [@assetFeedback]
      [asset]="asset()"
      [gallery]="gallery()"
      [galleryPermissions]="galleryPermissions()"
      [clientMode]="clientMode()"
      [is_liked]="asset().is_liked"
      [status]="asset().status"
      [color_label]="asset().color_label"
      [colorLabels]="colorLabels()"
      (toggleAssetLike)="toggleLike()"
      (updateAssetColorLabel)="updateColorLabel($event)"
      (updateAssetStatus)="updateAssetStatus($event)"
    ></app-asset-feedback>
  } @else {
    <app-asset-feedback-hints
      [@assetFeedbackHints]
      [assetId]="asset().id"
      [is_liked]="asset()['is_liked']"
      [likes]="asset().likes"
      [status]="asset().status"
      [color_label]="asset().color_label"
      [gallery]="gallery()"
      [galleryPermissions]="galleryPermissions()"
      [darkBackground]="true"
    >
    </app-asset-feedback-hints>
  }
}
